import { Box } from '../../../mads';
import { useI18n } from '../../I18n';
import { logTapButtonWithExtraParams } from '../../native-modules/tare/logTapButtonWithExtraParams';

import { colors, fontSizes, spacing } from '@indeed/ifl-tokens/react-native';
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- RNText needed for nested Text with onPress (inline links)
import { StyleSheet, Text as RNText } from 'react-native';

export interface GdprTosNoticeProps {
    language?: string;
    country?: string;
    pageName?: string;
    navigateToUrl?: (url: string) => void;
}

export function GdprTosNotice(props: GdprTosNoticeProps): React.JSX.Element | null {
    const i18n = useI18n();
    const pageName = props.pageName ?? 'viewjob';

    // Don't show for Japan
    if (props.country === 'JP') {
        return null;
    }

    const termsUrl = `https://www.indeed.com/legal?hl=${props.language || 'en'}`;

    const handleTermsPress = (): void => {
        void logTapButtonWithExtraParams(pageName, 'jobAlertTermsLink', [pageName], {});
        if (props.navigateToUrl) {
            props.navigateToUrl(termsUrl);
        }
    };

    const fullText = i18n.gettext(
        'By creating a job alert, you agree to our <a href="{0}" target="_blank" aria-label="Terms opens in a new tab" role="link">Terms</a>. You can change your consent settings at any time by unsubscribing or as detailed in our terms.',
        termsUrl,
    );

    // Parse HTML and render as RN components
    const match = fullText.match(/^(.*)<a[^>]*>([^<]*)<\/a>(.*)$/);
    if (!match) {
        return <RNText style={styles.noticeText}>{fullText}</RNText>;
    }

    const [, before, linkText, after] = match;

    return (
        <Box sx={styles.container}>
            <RNText style={styles.noticeText}>
                {before}
                <RNText
                    style={styles.linkText}
                    onPress={handleTermsPress}
                    accessibilityRole="link"
                    accessibilityLabel={i18n.gettext('Terms opens in a new tab')}
                >
                    {linkText}
                </RNText>
                {after}
            </RNText>
        </Box>
    );
}

const styles = StyleSheet.create({
    container: {
        marginTop: spacing.s5,
    },
    noticeText: {
        fontSize: fontSizes.f2,
        color: colors.foregroundWeak,
        lineHeight: fontSizes.f2 * 1.5,
    },
    linkText: {
        fontSize: fontSizes.f2,
        color: colors.foregroundActionActive,
        lineHeight: fontSizes.f2 * 1.5,
        textDecorationLine: 'underline',
    },
});
